import React from 'react';
import { Text, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { numberWithCommas } from '../../services/helpers.js';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';

/**
 *
 * @param {*} props
 */
export default function DeathDismemberment({ classes, expanded, deathDismemberment, handleChange, isStudent }) {
    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('deathDismemberment')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('deathDismemberment') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>{ i18n.t(tokens.titles.accidentalDeathAndDismemberment) }</Text>
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>

                    {
                        deathDismemberment.isEligible !== 1 ? 
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    { i18n.t(tokens.labels.coverage.ineligibleForBenefit)}
                                </Text>
                            </div>
                            : 
                            null
                    }

                    {
                        deathDismemberment.isFlatAmount === 1 ?
                            <Text small bold customStyle={{ flex: 1, marginTop: 10 }}>
                                { i18n.t(tokens.labels.coverage.coverageFlatAmount, { flatAmount: numberWithCommas(deathDismemberment.flatAmount) }) }
                            </Text>
                            :
                            <Text small bold customStyle={{ flex: 1, marginTop: 10 }}>
                                { i18n.t(tokens.labels.coverage.coverageTimesEarnings, { timesEarnings: deathDismemberment.timesEarnings }) }
                            </Text>
                    }

                    { 
                        deathDismemberment.maxEvidence > 0 ?
                            <Text small margin="5px 0px 0px 0px">
                                { i18n.t(tokens.labels.coverage.maxEvidenceLabel, { maxEvidence: numberWithCommas(deathDismemberment.maxEvidence) }) }
                            </Text>
                            :
                            null
                    }

                    {
                        deathDismemberment.maxNoEvidence > 0 ?
                            <Text small margin="5px 0px 0px 0px">
                                { i18n.t(tokens.labels.coverage.maxNoEvidenceLabel, { maxNoEvidence: numberWithCommas(deathDismemberment.maxNoEvidence) }) }
                            </Text>
                            :
                            null 
                    }

                    { 
                        isStudent ?  
                            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.terminatesAtEndOfStudy, { terminationAge: deathDismemberment.terminationAge }) }</Text>
                            :
                            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.terminatesAtAge, { terminationAge: deathDismemberment.terminationAge }) }</Text>
                    }

                    { 
                        isStudent ?  
                            <Text small margin="10px 0px 10px 0px">
                                { i18n.t(tokens.labels.coverage.coverageReducesAtAgeStudy, { reducesBy: deathDismemberment.reducesBy, reducesAtAge: deathDismemberment.reducesAtAge }) }
                            </Text>
                            :
                            <Text small margin="10px 0px 10px 0px">
                                { i18n.t(tokens.labels.coverage.coverageReducesAtAge, { reducesBy: deathDismemberment.reducesBy, reducesAtAge: deathDismemberment.reducesAtAge }) }
                            </Text>
                    }

                    { 
                        deathDismemberment.includeSecondReduction ?
                            <>
                                { 
                                    isStudent ?  
                                        <Text small margin="5px 0px 10px 0px">
                                            { i18n.t(tokens.labels.coverage.furtherCoverageReducesAtAgeStudy, { furtherReducesBy: deathDismemberment.furtherReducesBy, furtherReductionAge: deathDismemberment.furtherReductionAge }) }
                                        </Text>
                                        :
                                        <Text small margin="5px 0px 10px 0px">
                                            { i18n.t(tokens.labels.coverage.furtherCoverageReducesAtAge, { furtherReducesBy: deathDismemberment.furtherReducesBy, furtherReductionAge: deathDismemberment.furtherReductionAge }) }
                                        </Text>
                                }
                            </>
                            :
                            null
                    }
                </AccordionDetails>
            </Accordion>
        </div>
    );
}